module.exports = __webpack_public_path__ + "static/img/yomanet.d6cc67e.png";


//////////////////
// WEBPACK FOOTER
// ./static/yomanet.png
// module id = 361
// module chunks = 2